import React from 'react';
import BTabs from '@mui/material/Tabs';

const Tabs = ({ children, value, ...props}) =>{
  return  (<>
    <BTabs {...props} value={value} children={ children || null} />
  </>)
};
export default Tabs;
